import { AdministrativeReportColumn } from '../services/administrativeReportsService';
import { formatGiftDuration } from './giftDuration';

export type ColumnFilter = {text?: string; min?: string; max?: string};
export const normalizeReportSearch = (value: unknown) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
const day = (value: unknown) => {
    const text = String(value ?? '');
    if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return text;
    const parsed = new Date(text);
    if (Number.isNaN(parsed.getTime())) return '';
    return new Intl.DateTimeFormat('en-CA', {timeZone:'America/La_Paz', year:'numeric', month:'2-digit', day:'2-digit'}).format(parsed);
};
export const filterReportRows = (rows: Record<string, unknown>[], columns: AdministrativeReportColumn[], search: string, filters: Record<string, ColumnFilter>) => {
    const tokens = normalizeReportSearch(search).split(/\s+/).filter(Boolean);
    return rows.filter(row => {
        const haystack = normalizeReportSearch(columns.map(col => col.type === 'duration' ? formatGiftDuration(Number(row[col.key]) / 60) : row[col.key]).join(' '));
        if (!tokens.every(token => haystack.includes(token))) return false;
        return columns.every(col => {
            const filter = filters[col.key];
            if (!filter) return true;
            if (filter.text && !normalizeReportSearch(filter.text).split(/\s+/).every(token => normalizeReportSearch(row[col.key]).includes(token))) return false;
            const numeric = ['number', 'money', 'currency', 'duration'].includes(col.type || '');
            if (!filter.min && !filter.max) return true;
            if (row[col.key] === null || row[col.key] === undefined || row[col.key] === '') return false;
            const value = numeric ? Number(row[col.key]) / (col.type === 'duration' ? 60 : 1) : day(row[col.key]);
            if ((numeric && !Number.isFinite(value)) || (!numeric && !value)) return false;
            if (filter.min && value < (numeric ? Number(filter.min) : filter.min)) return false;
            if (filter.max && value > (numeric ? Number(filter.max) : filter.max)) return false;
            return true;
        });
    });
};
